export default __webpack_public_path__ + "a59131266c076f70fc19b682ec28bce9.png";